import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function WaterPanView({ onClose, open, prodd }) {
  const navigate = useNavigate();

 
  const items1 = [
    {
      key: "1",
      label: "Name of pan",
      children: prodd?.panName ?? "N/A",
    },
    
    {
      key: "2",
      label: "Water Source",
      children: prodd?.panWaterSource ?? "N/A",
    },
    
    {
      key: "4",
      label: "Estimated Beneficiaries",
      children: prodd?.panEstBeneficiaries ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.panStartDate
            ? moment(prodd?.panStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.panEndDate
            ? moment(prodd?.panEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Time Frame",
      children: prodd?.panTimeFrame ?? "N/A",
    },
    {
      key: "8",
      label: "Acreage",
      children: prodd?.panAcreage ?? "N/A",
    },
    {
      key: "9",
      label: "Remarks",
      children: prodd?.panRemarks ?? "N/A",
    },
    {
      key: "10",
      label: "Latitude (Decimal degrees, WGS84)",
      children: prodd?.panLat ?? "N/A",
    },
    {
      key: "11",
      label: "Longitude (Decimal degrees, WGS84)",
      children: prodd?.panLong ?? "N/A",
    },
    {
      key: "17",
      label: "Purpose/Water Use",
      children: prodd?.wuType ?? "N/A",
    },  
    {
      key: "18",
      label: "Lined",
      children: prodd?.panLined ?? "N/A",
    },  
    {
      key: "19",
      label: "Category",
      children: prodd?.panCategory ?? "N/A",
    },  
    
    
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.panCost)}</div>,
    },
   
    {
      key: "7",
      label: "Method of Abstraction",
      children: prodd?.waType ?? "N/A",
    },
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.panSourceFunds ?? "N/A",
    },
    {
      key: "8",
      label: "Crops",
      children: prodd?.panCrops ?? "N/A",
    },
    {
      key: "12",
      label: "Auxiliary",
      children: prodd?.panAuxiliariesId ?? "N/A",
    },
    {
      key: "13",
      label: "Treatment Type",
      children: prodd?.panTreatmentType ?? "N/A",
    },
    {
      key: "14",
      label: "Pathways",
      children: prodd?.panPathways ?? "N/A",
    },
    {
      key: "15",
      label: "Implementing Agency",
      children: prodd?.panAgency ?? "N/A",
    }, 
    {
      key: "16",
      label: "Managing Entity",
      children: prodd?.panManagingAgency ?? "N/A",
    },  
   
    
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">pan Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default WaterPanView;
